export default __webpack_public_path__ + "static/media/logo-row-light.31110ae0.svg";